import React from 'react';

import Question from './Question';
import Button from '../../shared/components/FormElements/Button/Button';
import './InterviewList.css';

const QuestionList = props => {


    /*
    var moduleToBeReviewed = [];

    for (module in props.items) {
        if (module.dateCompleted) {
            var t2 = module.dateCompleted.getTime();
            var t1 = Date().getTime();
            var timeDiff = (t2-t1)/(24*3600*1000);

            if (timeDiff > 7) {
                moduleToBeReviewed.push(module);
            }
        }
    }
    */
    if (props.items.length === 0) {
      return (
        <div className="interview-list center">
            <h3>No Question Found.</h3>
            <Button to="/new">Create Interview</Button>
        </div>
      );
    }

    return (
        <div>
        <ul className="interview-list">
          {props.items.map((question, index) => (
            <Question
              key={question._id}
              id={question._id}
              interviewId={question.interviewId}
              question={question.question}
              isAnswered={question.isAnswered}
              onDelete={props.onDeleteQuestion}
              index={index}
            />
          ))}
        </ul>
        </div>
      );
};

export default QuestionList;